import PropTypes from "prop-types"
import styles from "./connect_url.module.scss"

const ClickVerify = ({ onSubmit, overlayColor, localization }) => (
  <div className={styles["verify-service"]}>
    <a
      onClick={e => {
        e.preventDefault()
        onSubmit()
      }}
      href="#"
      className={styles["big-button"]}
      style={{ backgroundColor: overlayColor }}
    >
      <span>{localization.continue}</span>
    </a>
  </div>
)

ClickVerify.propTypes = {
  overlayColor: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  localization: PropTypes.shape({
    continue: PropTypes.string.isRequired,
  }),
}

export default ClickVerify
